package com.appsyde.shared.modules.account.domain.usecase

import com.appsyde.shared.modules.account.domain.repository.AccountRepository

class UpdateAccountToneUseCase(
    private val accountRepository: AccountRepository
) {
    suspend operator fun invoke(tone: String) {
        accountRepository.updateTone(tone)
    }
}
